import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Button, Modal } from '@cloud/atom-ui';
import { InfoOutlined } from '@cloud/atom-ui-icons';
import './index.less'

function ConfirmModal(props) {
  const { maskClosable } = props;
  const [visible, setVisible] = useState(false);
  const [destroy, setDestroy] = useState(false);
  const handleCancel = () => {
    props.onClose?.();
    close();
  };
  useEffect(() => {
    setVisible(true);
  }, []);
  const onConfirm = () => {
    props.onConfirm?.();
    close();
  };
  const close = () => {
    setVisible(false);
    setTimeout(() => {
      setDestroy(true);
    }, 800);
  };
  if (destroy) {
    return null;
  }

  return (
    <Modal
      title={props.title}
      wrapClassName={'confirm-modal'}
      visible={visible}
      onCancel={handleCancel}
      onOk={onConfirm}
      zIndex={9999}
      closable={!!props?.hideClosable}
      maskClosable={maskClosable !== undefined ? maskClosable : true}
      footer={[
        <>
          {!props.hideCancel && (
            <Button
              className={'modal-button'}
              key="back"
              style={{ backgroundColor: '#FFF', borderColor: '#DDD', color: '#595959' }}
              onClick={handleCancel}
            >
              {props.cancelText || '取消'}
            </Button>
          )}
        </>,
        <Button
          key="submit"
          type="primary"
          onClick={onConfirm}
          className={'modal-button'}
          style={{ backgroundColor: '#008DFF', borderColor: '#008DFF', color: '#FFF', ...props?.btnStyle }}
        >
          {props.okText || '确定'}
        </Button>,
      ]}
    >
      <p>
        <span className={'info-icon'}>
          <InfoOutlined />
        </span>
        {props.content}
      </p>
    </Modal>
  );
}

/* 自定义Confirm弹窗 */
export const confirm = (options) => {
  return new Promise((resolve, reject) => {
    const onClose = () => {
      resolve(false);
      removeContainerDom();
    };
    const onOk = () => {
      resolve(true);
      removeContainerDom();
    };

    if (options.onlyOneModal) {
      // 清除已存在的弹窗节点
      removeAlreadyModal();
    }

    let containerDom;
    if (document.getElementById('pc-confirm')) {
      containerDom = document.getElementById('pc-confirm');
    } else {
      containerDom = document.createElement('div');
      containerDom.setAttribute('id', 'pc-confirm');
      containerDom.classList.add('mask');
      document.body.appendChild(containerDom);
    }
    ReactDOM.render(<ConfirmModal onClose={onClose} onConfirm={onOk} {...options} />, containerDom);
  });
};

const removeAlreadyModal = () => {
  const bodyLastChild = document.body.lastChild;
  if (bodyLastChild) {
    const childDom = bodyLastChild.childNodes;
    if (childDom && childDom[0] && (childDom[0]).className === 'amu-modal-root') {
      document.body.removeChild(bodyLastChild);
    }
  }
};

const removeContainerDom = () => {
  const dom = document.getElementById('pc-confirm');
  dom && document.body.removeChild(dom);
};
